import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Background from '../../../static/images/bac-360/img-hero-desktop.png'
import Tarjetas from '../../../static/images/bac-360/img-combo.svg'


const Container = styled.div`
  position: relative;
  text-align: center;
  margin: 0 auto;
  background-position-x: -352px;
  background-repeat: no-repeat;
  background-size: cover;

  h1 {
    font-size: 2em;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('tablet')`
     background-size: auto;
`}  

  ${breakpoint('desktop')`
    background-position-x: 0;
    background-size: cover;
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}    background-size: auto;
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;
  `}
`

const DivContent = styled.div `
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 50px 0px;
    position: relative;
    top: 210px;
    box-shadow: 4px 3px 7px 2px #797979;

    & h2 {
        color:${props => props.theme.colors.rojoBac};
        font-weight:400;
        font-size: 40px;
    }

    & p {
        font-size: 27px;
    }

    & img{
        width: 400px;
    }

    ${breakpoint('tablet')`
        padding: 55px 40px;
        display: flex;
        text-align: left;
        justify-content: center;

        & > div {
        max-width: 500px;
        box-sizing: border-box;
        }

        & > div:first-of-type {
            padding-right: 20px;
        }

        & img{
            width: 350px;
        }

        & p {
            font-size: 18px;
        }
    `}
`

const ButtonForm = styled.a `
    padding: 26px;
    font-size: 23px;
    width: 75%;
    background: ${props => props.theme.colors.amexBlue};
    text-align: center;
    margin: 0 auto;
    display: block;
    color: white;
    text-decoration: none;
    font-weight: 600;

    ${breakpoint('tablet')`
        width: auto;
        padding: 15px;  
        font-size: 18px;
    `}
`


const DivButtons = styled.div `
    padding: 20px;
    ${breakpoint('tablet')`
        width:40%;
    `}
   
`
const DivText = styled.div `
    padding: 50px;   
    ${breakpoint('tablet')`
        width:60%;
        padding: 0px;   
    `}
   
`

const ImgMovil = styled.img `
    margin-top: -170px;
    margin-bottom: -30px;

    ${breakpoint('tablet')`
        display:none;
    `}
`

const ImgDesktop = styled.img `
    display:none;
    ${breakpoint('tablet')`
        display:block;  
    `}
`

const DivButtons1 = styled.div `
    padding: 20px;
    ${breakpoint('tablet')`
        display:none;
    `}
   
`

const ContentButtons = styled.div `
    margin-top: -25px;
    ${breakpoint('tablet')`
        margin-top: 15px;
    `}  
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container style={{ backgroundImage: `url(${Background})`}}>
    <Wrapper>
        <DivContent>
            <DivButtons1>
                    <ImgMovil alt="Combo BAC" src={Tarjetas}></ImgMovil>
            </DivButtons1>
            <DivText>
                <h2>Cuenta de ahorro, tarjeta de crédito y Compass</h2>
                <p><strong>Queremos que estés más Pura Vida, por eso te ofrecemos soluciones financieras que mejoran tu vida.</strong></p>
                <p>Solicitá hoy, 100% en línea, de manera fácil y ágil una cuenta total, una tarjeta de crédito y tu Compass con tan solo llenar un formulario y te los llevamos a tu casa.</p>
            </DivText>  
            <DivButtons>
                <ImgDesktop alt="Combo BAC" src={Tarjetas}></ImgDesktop>
                <ContentButtons><ButtonForm href="#">Llená la solicitud</ButtonForm></ContentButtons>
            </DivButtons>
        </DivContent>
    </Wrapper>
  </Container>
);

export default Header